/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyDetailResponse } from '../../models/company-detail-response';
import { UpdateCompanyRequest } from '../../models/update-company-request';

export interface PutApiAdministrativeV1Id$Json$Params {

/**
 * The unique identifier of the company to update.
 */
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The request payload containing updated company details.
     */
    body?: UpdateCompanyRequest
}

export function putApiAdministrativeV1Id$Json(http: HttpClient, rootUrl: string, params: PutApiAdministrativeV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyDetailResponse>> {
  const rb = new RequestBuilder(rootUrl, putApiAdministrativeV1Id$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyDetailResponse>;
    })
  );
}

putApiAdministrativeV1Id$Json.PATH = '/private/v1/companies/{id}';
